import {DataFetcher} from '@aboutyou/data-fetcher';
import {
  ErrorPageInline,
  SkeletonBlock,
  desktopAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {useImagesSection} from '../useGetProductBulkSection';
import {
  ProductImageGridView,
  ProductImageGridViewProps,
} from './ProductImageGridView';
import {useComputeDefaultState} from './useComputeDefaultState';

export const ProductImageGrid: FC<ProductImageGridViewProps> = props => {
  const defaultState = useComputeDefaultState();

  return (
    <DataFetcher
      request={useImagesSection()}
      Error={ErrorPageInline}
      View={ProductImageGridView}
      Loading={Loading}
      viewProps={props}
      computeDefaultState={() => defaultState}
    />
  );
};

const Loading = () => {
  return (
    <SkeletonWrapper>
      <ProductImageSkeleton />
      <ProductImageSkeleton />
      <ProductImageSkeleton />
      <ProductImageSkeleton />
      <ProductImageSkeleton />
      <ProductImageSkeleton />
    </SkeletonWrapper>
  );
};

const SkeletonWrapper = styled.div`
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
`;

const ProductImageSkeleton = styled(SkeletonBlock)`
  aspect-ratio: 3 / 4;
  margin: 0;
  height: auto;

  ${desktopAndUpLinaria(`width: calc(50% - 2px);`)}
`;
